// ColumnsMenu — toggle which Dev Tracker table columns are visible (Wave 2).
// Title is always on. Selection is kept in the parent so it can be passed to
// ItemTable's `visibleColumns`.

import { useEffect, useRef, useState } from "react";
import { Columns3, Check } from "lucide-react";
import { ITEM_COLUMNS } from "../../pages/Dashboard";

// Column keys offered in the menu, in table order. Title is locked on.
const TOGGLEABLE = ["talmia_version", "area", "type", "status", "priority", "function", "effort", "impact", "roi", "phase", "assigned_to", "ai_pct", "updated_at"];

export default function ColumnsMenu({ visible, onChange }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, [open]);

  const toggle = (key) => {
    const has = visible.includes(key);
    // Rebuild in canonical order so columns keep a stable left-to-right layout.
    const next = ["title", ...TOGGLEABLE].filter((k) => k === "title" || (has ? (k !== key && visible.includes(k)) : (visible.includes(k) || k === key)));
    onChange(next);
  };

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        data-testid="columns-menu-trigger"
        className="inline-flex items-center gap-1.5 px-3 py-2 rounded-md text-sm border border-white/10 bg-white/[0.02] text-slate-200 hover:bg-white/5"
      >
        <Columns3 className="w-4 h-4" /> Columns
      </button>
      {open && (
        <div className="absolute right-0 z-50 mt-1.5 min-w-[180px] rounded-lg border border-white/10 bg-slate-900/95 backdrop-blur-sm shadow-2xl p-1.5" data-testid="columns-menu-popover">
          {TOGGLEABLE.map((key) => {
            const active = visible.includes(key);
            return (
              <button
                key={key}
                type="button"
                onClick={() => toggle(key)}
                data-testid={`columns-toggle-${key}`}
                className={`w-full text-left flex items-center gap-2 px-2 py-1.5 rounded text-sm ${active ? "text-white" : "text-slate-400 hover:bg-white/5"}`}
              >
                <span className={`w-4 h-4 rounded border grid place-items-center shrink-0 ${active ? "bg-orange-500/80 border-orange-400" : "border-white/20"}`}>
                  {active && <Check className="w-3 h-3 text-white" />}
                </span>
                {ITEM_COLUMNS[key].label}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
